import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Badge, Col, Form, ListGroup, Row } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAnglesUp, faEquals } from '@fortawesome/pro-solid-svg-icons';
import { CONTACT_MODEL, PROPERTY_MODEL } from '../../../constants';
import { faBuilding, faUser } from '@fortawesome/free-solid-svg-icons';

const RECORD_TYPE_ICON = {
  [CONTACT_MODEL]: faUser,
  [PROPERTY_MODEL]: faBuilding,
};

export default function Tasks({ task, showConnectionBadges, onEdit, onUpdate }) {
  const [saving, setSaving] = useState(false);

  const handleCompleteToggle = useCallback(() => {
    setSaving(true);
    setTimeout(() => {
      onUpdate({ id: task.id, completed: !task.completedAt }).catch(() => setSaving(false));
    }, 500);
  }, []);

  const handleEdit = useCallback((e) => {
    e.preventDefault();
    onEdit(task);
  }, [task]);

  const priorityDisplay = (
    <span>
      {task.priority === 'low' && (<FontAwesomeIcon className="text-success" icon={faAngleDown} />)}
      {task.priority === 'medium' && (<FontAwesomeIcon className="text-warning" icon={faEquals} />)}
      {task.priority === 'high' && (<FontAwesomeIcon className="text-danger" icon={faAnglesUp} />)}
    </span>
  );

  return (
    <ListGroup.Item>
      <Row className="gx-3">
        <Col xs="auto">
          <Form.Check
            defaultChecked={!!task.completedAt}
            disabled={saving}
            type="checkbox"
            onChange={handleCompleteToggle}
          />
          <div className="mt-2 d-lg-none">
            {priorityDisplay}
          </div>
        </Col>
        <Col>
          <Row>
            <Col>
              <a href="#" onClick={handleEdit}><strong >{task.name}</strong></a>
              <div>{task.description}</div>
              <div className="d-flex gap-3">
                {task.dueDate && <small>Due: {(new Date(task.dueDate)).toDateString()}</small>}
                {task.completedAt && (
                  <small className="text-success">Completed: {(new Date(task.completedAt)).toDateString()}</small>
                )}
              </div>
            </Col>
            {showConnectionBadges !== false && (
              <Col className="align-self-center d-flex gap-2 flex-wrap" lg={6} >
                {task.connectedRecordsAttributes.map(connectedRecord => (
                  <Badge bg="light" key={connectedRecord.id} pill text="dark">
                    <FontAwesomeIcon icon={RECORD_TYPE_ICON[connectedRecord.connectedRecordType]} />
                    <small>{connectedRecord.label}</small>
                  </Badge>
                ))}
              </Col>
            )}
            <Col className="d-none d-lg-block" xs="auto">
              {priorityDisplay}
            </Col>
          </Row>
        </Col>
      </Row>
    </ListGroup.Item>
  );
}

Tasks.propTypes = {
  showConnectionBadges: PropTypes.bool,
  task: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};
